/**
 * Grid provider model.
 */
export class GridModel<T, TGridFilter extends GridFilter> {
  filter: GridFilter & TGridFilter;
  collection: GridCollection<T>;

  onTextSearch: (searchClause: string, prop: string) => void;
  onSearch: (searchClause?: any) => void;
  onFilter: () => void;
  clearSearch: (filter: GridFilter) => void;
  sort: (params: ElSortParams) => void;
  goToPage: (page: number) => void;
  prev: () => void;
  next: () => void;
  first: () => void;
  last: () => void;

  isFirstPage: () => boolean;
  isLastPage: () => boolean;
}

/**
 * Element UI sort-change event params.
 */
export class ElSortParams {
  column: object;
  order: string;
  prop: string;
}

/**
 * Grid collection fetch filter used to page/sort/search.
 */
export class GridFilter {
  /**
   * Page to fetch.
   */
  page?: number;

  /**
   * Amount of items to fetch.
   */
  pageSize?: number;

  /**
   * Sort by KEY (entity field name).
   */
  sortBy?: string;

  /**
   * Sort direction (optional).
   * Allowed: "ascending" / "descending".
   */
  sortOrder?: string;

  /**
   * Include soft deleted entities?
   */
  includeDeleted?: boolean;

  /**
   * Collection owner user Id.
   */
  userId?: number;

  search?: string;
}

/**
 * Grid collection model.
 */
export class GridCollection<T> {
  currentPage: number;
  pageCount: number;
  pageSize: number;
  totalItemCount: number;
  items: T[];
}
